import React, { useEffect, useState } from "react";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import PrivatePopup from "../../Layouts/PrivateRouteLayouts/PrivatePopup";
import { useNavigate, useParams } from "react-router-dom";
import { getCatagorybyidforHire } from "../../../redux/hire/action";
import { useDispatch, useSelector } from "react-redux";
import PostNotFound from "../../CustomComponents/AllLoader/PostNotFound";
import SearchSubcategory from "./SearchSubcategory";

export default function HireExpertsByCategory() {
  const { id } = useParams();
  const path = "Assets/scss/hireexpert.module.scss";
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const laung = localStorage.getItem("laung");
  const [lan] = useState(laung ?? "en");
  const [search, setSearch] = useState("");

  const categorydetails = useSelector(
    ({ hire: { getcatagorybyidforhire } }) => getcatagorybyidforhire
  );

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  // fetch data dynamically based on search
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      dispatch(getCatagorybyidforHire(id, search));
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [id, search]);

  const navigatetofilerhire = (cat, subcat) => {
    const data = {
      industry_id: categorydetails?.id,
      industry_name: categorydetails?.title,
      category_id: cat?.id,
      category_name: cat?.title,
      subcategory_id: subcat?.id,
      subcategory_name: subcat?.title,
    };
    navigate(`/${lan}/filterandhirexperts`, { state: { indcatsub: data } });
  };

  const handleImageError = (e) => {
    e.target.src = `${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`;
  };

  return (
    <>
      <PrivatePopup />
      <div className="expert-by">
        <img
          src={categorydetails?.image}
          onError={handleImageError}
          className="w-100"
          alt=""
        />
        <div className="it-overlay"></div>
        <div className="develop-content">
          <h2>{categorydetails?.title}</h2>
          <p>Find experts to develop your ideas</p>
        </div>
      </div>

      {/* 🔍 Pass setSearch to handle dynamic API calls */}
      <SearchSubcategory setSearch={setSearch} search={search} placeholder={"Search Categories"} />

      {Array.isArray(categorydetails?.category) &&
      categorydetails?.category?.length > 0 ? (
        <div className="expert-detail">
          <div className="row expertdetail-row">
            {categorydetails?.category?.map((cat, catindex) => (
              <div key={catindex} className="col-md-3">
                <img
                  src={cat?.image}
                  onError={handleImageError}
                  className="w-100"
                  alt=""
                  onClick={() => navigatetofilerhire(cat, "")}
                />
                <h6>{cat?.title}</h6>
                <div className="website-link">
                  {cat?.subcategory?.map((sub, subvindex) => (
                    <a key={subvindex} onClick={() => navigatetofilerhire(cat, sub)}>
                      {sub?.title}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <PostNotFound title={"No Categories for this Industry"} />
      )}
    </>
  );
}
